// @flow
import { getTicket } from '../../../duck/selectors';

export { getTicket } from '../../../duck/selectors';

export default {
    getTicket,
};
